__turbopack_context__.v({
  "answer": "AskLab-module__QsDXAG__answer",
  "asklab-fade": "AskLab-module__QsDXAG__asklab-fade",
  "asklab-rise": "AskLab-module__QsDXAG__asklab-rise",
  "asklab-stop-pulse": "AskLab-module__QsDXAG__asklab-stop-pulse",
  "backdrop": "AskLab-module__QsDXAG__backdrop",
  "body": "AskLab-module__QsDXAG__body",
  "busyTag": "AskLab-module__QsDXAG__busyTag",
  "chip": "AskLab-module__QsDXAG__chip",
  "chips": "AskLab-module__QsDXAG__chips",
  "closeBtn": "AskLab-module__QsDXAG__closeBtn",
  "err": "AskLab-module__QsDXAG__err",
  "exchange": "AskLab-module__QsDXAG__exchange",
  "foot": "AskLab-module__QsDXAG__foot",
  "head": "AskLab-module__QsDXAG__head",
  "headRight": "AskLab-module__QsDXAG__headRight",
  "input": "AskLab-module__QsDXAG__input",
  "inputRow": "AskLab-module__QsDXAG__inputRow",
  "inputTerm": "AskLab-module__QsDXAG__inputTerm",
  "keys": "AskLab-module__QsDXAG__keys",
  "list": "AskLab-module__QsDXAG__list",
  "modeTag": "AskLab-module__QsDXAG__modeTag",
  "noMotion": "AskLab-module__QsDXAG__noMotion",
  "note": "AskLab-module__QsDXAG__note",
  "opt": "AskLab-module__QsDXAG__opt",
  "optActive": "AskLab-module__QsDXAG__optActive",
  "optHint": "AskLab-module__QsDXAG__optHint",
  "optLabel": "AskLab-module__QsDXAG__optLabel",
  "panel": "AskLab-module__QsDXAG__panel",
  "prompt": "AskLab-module__QsDXAG__prompt",
  "q": "AskLab-module__QsDXAG__q",
  "stopBtn": "AskLab-module__QsDXAG__stopBtn",
  "stopDot": "AskLab-module__QsDXAG__stopDot",
  "term": "AskLab-module__QsDXAG__term",
  "termAccent": "AskLab-module__QsDXAG__termAccent",
  "termDim": "AskLab-module__QsDXAG__termDim",
  "termError": "AskLab-module__QsDXAG__termError",
  "termLine": "AskLab-module__QsDXAG__termLine",
  "thinking": "AskLab-module__QsDXAG__thinking",
  "transcript": "AskLab-module__QsDXAG__transcript",
});
